import { useMemo } from 'react';

export default function FloatingParticles({ count = 25 }: { count?: number }) {
  const particles = useMemo(() =>
    Array.from({ length: count }, (_, i) => ({
      id: i,
      width: Math.random() * 4 + 2,
      height: Math.random() * 4 + 2,
      top: Math.random() * 100,
      left: Math.random() * 100,
      duration: 2 + Math.random() * 3,
      delay: Math.random() * 2,
    })),
    [count]
  );

  return (
    <>
      {particles.map((p) => (
        <div
          key={p.id}
          style={{
            position: 'absolute',
            borderRadius: '50%',
            background: 'rgba(255, 200, 100, 0.3)',
            filter: 'blur(1px)',
            width: p.width,
            height: p.height,
            top: `${p.top}%`,
            left: `${p.left}%`,
            animation: `pulse ${p.duration}s ease-in-out ${p.delay}s infinite alternate`,
          }}
        />
      ))}
    </>
  );
}